import "../../../../App.css"
import { useEffect, useState } from 'react';
import NavbarVerical from '../../../Navbar/navbarVertical';
import { Card, Form, Row, Col, Button, DropdownButton, Table, CardBody } from 'react-bootstrap';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getCourse, postDateConfiguration, getDateConfiguration, editdateConfiguration } from "../../../api/dateconfiguration";


function DateConfiguration() {
    const [error, setError] = useState("");
    const [courses, setCourses] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [active, setActive] = useState(false);
    const [configurations, setConfigurations] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false); // Track edit mode
    // const [editId, setEditId] = useState(null);

    const token =
        typeof window !== "undefined" ? localStorage.getItem("token") : null;


    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const [coursesRes] = await Promise.all([
                    getCourse(token),
                ]);
                setCourses(coursesRes.data);
            } catch (error) {
                setError("Error fetching data:", error);
            }
        };
        fetchInitialData();
    }, [token]);

    const handleCourseChange = (e) => {
        const courseId = e.target.value;
        setSelectedCourse((prevSelected) =>
            prevSelected.includes(courseId)
                ? prevSelected.filter((id) => id !== courseId) // Remove if already selected
                : [...prevSelected, courseId] // Add if not selected
        );
    };

    useEffect(() => {
        const fetchDateConfiguration = async () => {
            try {
                const response = await getDateConfiguration(token);
                setConfigurations(response.data);
                console.log("Date Configuration Data", response.data);
            } catch (error) {
                console.error("Error fetching social reservations:", error);
            }
        };
        fetchDateConfiguration();
    }, [token]);

    const handleEdit = (config) => {
        // Populate form fields with selected configuration data for editing
        setIsEditMode(true);
        // setSelectedCourse([config.course.id]); 
        setSelectedCourse(
            config.course ? [String(config.course.id)] : []
        );
        setStartDate(config.startDate);
        setEndDate(config.endDate);
        setStartTime(config.startTime);
        setEndTime(config.endTime);
        setActive(config.active);
    };

    const handleSubmit = async () => {
        try {
            if (selectedCourse.length === 0) {
                setError("Please select at least one course.");
                return;
            }
            setError("");

            // Helper function to format time
            const formatTime = (time) => {
                const [hours, minutes] = time.split(":");
                return `${hours}:${minutes}:00`;
            };

            const formattedStartTime = formatTime(startTime);
            const formattedEndTime = formatTime(endTime);

            // Construct request body dynamically based on mode
            const requestBody = isEditMode
                ? {
                    courseId: selectedCourse[0], // Assuming only one course can be edited at a time
                    startDate,
                    endDate,
                    startTime: formattedStartTime,
                    endTime: formattedEndTime,
                    active,
                }
                : {
                    courseIds: selectedCourse.map(Number), // Assuming multiple courses can be added
                    startDate,
                    endDate,
                    startTime: formattedStartTime,
                    endTime: formattedEndTime,
                    active: active.toString(),
                };

            console.log("Request Body:", requestBody);

            if (isEditMode) {
                // Edit existing configuration
                const response = await editdateConfiguration(requestBody, token);
                console.log("Edit Response:", response);
                toast.success("Date configuration updated successfully!");
                setIsEditMode(false); // Exit edit mode
            } else {
                // Create a new configuration
                const response = await postDateConfiguration(requestBody, token);
                console.log("Post Response:", response);
                toast.success("Date configuration submitted successfully!");
            }

            // Fetch the updated configurations
            const updatedResponse = await getDateConfiguration(token);
            setConfigurations(updatedResponse.data);

            // Reset the form
            setStartDate("");
            setEndDate("");
            setStartTime("");
            setEndTime("");
            setActive(false);
            setSelectedCourse([]);
        } catch (err) {
            console.error("Error posting date configuration:", err.response?.data || err.message || err);
            toast.error("Failed to submit date configuration. Please try again.");
        }
    };

    return (
        <>
            <NavbarVerical />
            <div className="content-area">
                <Card>
                    <Card.Body>
                        <p style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}>Date Configuration</p>
                        <Form>
                            <Row className='mt-4'>
                                <Col>

                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown">
                                            Course<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <DropdownButton
                                                title={
                                                    selectedCourse.length > 0
                                                        ? courses
                                                            .filter((course) => selectedCourse.includes(String(course.id)))
                                                            .map((course) => course.courseName)
                                                            .join(", ")
                                                        : "Select Course"
                                                }
                                                id="course-dropdown"
                                                className="course-dropdown"
                                            >
                                                <div style={{ padding: '10px' }}>
                                                    {courses.map((course) => (
                                                        <Form.Check
                                                            key={course.id}
                                                            type="checkbox"
                                                            id={`course - ${course.id}`}
                                                            value={course.id}
                                                            label={course.courseName}
                                                            checked={selectedCourse.includes(String(course.id))} // Ensure this line is present
                                                            onChange={handleCourseChange}
                                                        />

                                                    ))}
                                                </div>
                                            </DropdownButton>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label className="col-sm-3 col-form-label form-label">
                                            Start Date<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control type="date"
                                                value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label className="col-sm-3 col-form-label form-label">
                                            End Date<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control type="date"
                                                value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label className="col-sm-3 col-form-label form-label">
                                            Start Time<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control type="time"
                                                value={startTime} onChange={(e) => setStartTime(e.target.value)} />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label className="col-sm-3 col-form-label form-label">
                                            End Time<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control type="time"
                                                value={endTime} onChange={(e) => setEndTime(e.target.value)} />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label className="col-sm-3 col-form-label form-label">
                                            Active
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Check
                                                type="checkbox"
                                                id="activeCheckbox"
                                                label="Check If Active"
                                                checked={active}
                                                onChange={(e) => setActive(e.target.checked)}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="d-flex align-items-center justify-content-center mb-3">

                                            <Button variant="primary" type="button" onClick={handleSubmit}>
                                                {isEditMode ? "Update" : "Submit"}
                                            </Button>
                                            <ToastContainer />
                                            <Button variant="secondary" type="button" style={{ marginLeft: "10px" }}>
                                                Cancel
                                            </Button>
                                            <Button variant="primary" type="button" style={{ marginLeft: "10px" }}>
                                                Report
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Table responsive striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>Action</th>
                                                <th>Course</th>
                                                <th>Start Date</th>
                                                <th>End Date</th>
                                                <th>Start Time</th>
                                                <th>End Time</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {configurations.map((config, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <Button variant="secondary" onClick={() => handleEdit(config)}>  <i className="bi bi-pencil-fill me-2" />Edit</Button>
                                                    </td>
                                                    <td>{config.course.courseName}</td>
                                                    <td>{config.startDate}</td>
                                                    <td>{config.endDate}</td>
                                                    <td>{config.startTime}</td>
                                                    <td>{config.endTime}</td>
                                                </tr>
                                            ))}
                                        </tbody>

                                    </Table>
                                </Col>
                            </Row>


                        </Form>
                    </Card.Body>
                </Card>
                
            </div>


        </>
    );
}

export default DateConfiguration;